import { SalesByValueReportItem } from '../types/salesByValueReportItem'

export const getSalesByValueReportAllSummary = (salesReport: SalesByValueReportItem[]) => {
  return salesReport.map((report) => report.summary.all)
}
